export default __webpack_public_path__ + "static/media/instagram_button.28c77ba1.svg";